var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgContent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 48,
    viewBox: "0 0 49 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#content_svg__clip0_5324_36775)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    width: 48,
    height: 48,
    rx: 12,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    width: 48,
    height: 48,
    rx: 12,
    fill: "url(#content_svg__paint0_linear_5324_36775)"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#content_svg__clip1_5324_36775)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    width: 48,
    height: 48,
    rx: 12,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    width: 48,
    height: 48,
    rx: 12,
    fill: "url(#content_svg__paint1_linear_5324_36775)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.686 0h21.628c4.585 0 6.248.477 7.924 1.374a9.346 9.346 0 013.888 3.888C48.023 6.938 48.5 8.6 48.5 13.186v21.628c0 4.585-.477 6.248-1.374 7.924a9.347 9.347 0 01-3.888 3.888C41.562 47.523 39.9 48 35.314 48H13.686c-4.585 0-6.248-.477-7.924-1.374a9.346 9.346 0 01-3.888-3.888C.977 41.062.5 39.4.5 34.814V13.186C.5 8.6.977 6.938 1.874 5.262a9.346 9.346 0 013.888-3.888C7.438.477 9.1 0 13.686 0z",
    fill: "url(#content_svg__paint2_linear_5324_36775)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.071 24c0-8.522 6.909-15.429 15.429-15.429 2.105 0 4.154.423 6.052 1.234a2.493 2.493 0 011.314 3.269 2.487 2.487 0 01-3.265 1.315 10.415 10.415 0 00-4.101-.834c-5.773 0-10.452 4.677-10.452 10.445 0 5.768 4.679 10.445 10.452 10.445S34.952 29.768 34.952 24a2.49 2.49 0 012.488-2.492A2.49 2.49 0 0139.928 24c0 8.522-6.908 15.429-15.428 15.429S9.07 32.522 9.07 24zm23.643-7.066c0-.727.295-1.386.772-1.863a2.628 2.628 0 011.594-.758l.27-.013c.727 0 1.386.295 1.863.771.477.477.772 1.136.772 1.864 0 .727-.295 1.386-.772 1.863a2.627 2.627 0 01-1.863.771 2.627 2.627 0 01-1.864-.771 2.626 2.626 0 01-.772-1.863z",
    fill: "url(#content_svg__paint3_linear_5324_36775)"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "content_svg__paint0_linear_5324_36775",
    x1: 24.5,
    y1: 0,
    x2: 24.5,
    y2: 48,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D0D5DD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "content_svg__paint1_linear_5324_36775",
    x1: 24.5,
    y1: 0,
    x2: 24.5,
    y2: 48,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D0D5DD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "content_svg__paint2_linear_5324_36775",
    x1: 24.5,
    y1: 52.848,
    x2: 24.5,
    y2: -5.629,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#25F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0AF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "content_svg__paint3_linear_5324_36775",
    x1: 24.5,
    y1: 8.571,
    x2: 24.5,
    y2: 39.429,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEFEFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F3F3F3"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "content_svg__clip0_5324_36775"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    width: 48,
    height: 48,
    rx: 12,
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "content_svg__clip1_5324_36775"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    width: 48,
    height: 48,
    rx: 12,
    fill: "#fff"
  })))));
}
export default SvgContent;